import { render, staticRenderFns } from "./BasketUpload.vue?vue&type=template&id=181b0f86&scoped=true&"
import script from "./BasketUpload.vue?vue&type=script&lang=ts&"
export * from "./BasketUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b0f86",
  null
  
)

export default component.exports